import axios from "axios";
import { buildHeaders } from "@/services/_headers.util";

const BASE = `${process.env.VUE_APP_API_URL}payroll/bank-transfer-templates`;

export default {
  meta() {
    return axios.get(`${BASE}/meta`, { headers: buildHeaders() });
  },

  list() {
    return axios.get(BASE, { headers: buildHeaders() });
  },

  get(id) {
    return axios.get(`${BASE}/${id}`, { headers: buildHeaders() });
  },

  create(payload) {
    return axios.post(BASE, payload, { headers: buildHeaders() });
  },

  update(id, payload) {
    return axios.put(`${BASE}/${id}`, payload, { headers: buildHeaders() });
  },

  remove(id) {
    return axios.delete(`${BASE}/${id}`, { headers: buildHeaders() });
  },

  preview(id, params = {}) {
    return axios.post(`${BASE}/${id}/preview`, params, { headers: buildHeaders() });
  },

  duplicate(id) {
    return axios.post(`${BASE}/${id}/duplicate`, {}, { headers: buildHeaders() });
  },

  previewExport(id, params = {}) {
    const format = params.format || "xlsx";
    return axios.get(`${BASE}/${id}/preview-export`, {
      params: { ...params, format },
      headers: buildHeaders(),
      responseType: "blob",
    });
  },

  importHeaders(file, { headerRow = 2, numberRow = 1 } = {}) {
    const fd = new FormData();
    fd.append("file", file);
    fd.append("header_row", String(headerRow));
    fd.append("number_row", String(numberRow));
    return axios.post(`${BASE}/import-headers`, fd, {
      headers: {
        ...buildHeaders(),
        "Content-Type": "multipart/form-data",
      },
    });
  },
};
